export const PAGE_TITLES = {
  home: 'LulPay: Send money home to Uganda from your bank app',
  privacy: 'Privacy Policy — LulPay',
  terms: 'Terms of Use — LulPay',
  notFound: 'Page not found — LulPay',
} as const;
